import React from "react";
import { DropzoneArea } from "material-ui-dropzone";
// import dynamic from "next/dynamic";

// const DropzoneArea = dynamic(
//   () => import("material-ui-dropzone").then(res => res.DropzoneArea),
//   {
//     ssr: false
//   }
// );

export default function Dropzone({ props, setFiles }: any) {
  return (
    <DropzoneArea
      dropzoneText={"Drag document or click to upload"}
      onChange={setFiles}
      {...props}
    />
  );
}
